export default function checkVisibility(element: HTMLElement, options?: CheckVisibilityOptions ) {
	if (typeof element !== 'object' || !(element instanceof HTMLElement)) return null;

	if ('checkVisibility' in element) return element.checkVisibility(options);

	if ('getBoundingClientRect' in element) {
		// @ts-expect-error TS assumes it's never because of previous checks, but checkVisibility is a newer feature so it
		// may not exist
		const rect: DOMRect = element.getBoundingClientRect(); 

		// Checks that all of the values for the bounding box are zero, which is what is returned when it isn't visible
		const keys = ['top', 'right', 'bottom', 'left', 'height', 'width'] as Array<keyof DOMRect>;
		return !keys.every((key) => rect[key] === 0);
	}
	
	return null;
}